import { TruckIcon } from '../Icons';
import { useAppSettings } from '../../hooks/queries';

export const SplashScreen = () => {
  const { data: settings } = useAppSettings();
  const logoSrc = settings?.customLogo || './logo.svg';

  return (
    <div className="fixed inset-0 flex flex-col items-center justify-center bg-gray-50 dark:bg-gray-900 z-50 transition-opacity duration-500">
      <div className="relative mb-8">
        <div className="absolute inset-0 bg-blue-500 rounded-full blur-3xl opacity-20 animate-pulse"></div>
        {/* Logo Image */}
        <img
          src={logoSrc}
          alt="App Logo"
          className="h-32 w-32 object-contain relative z-10 drop-shadow-xl"
          onError={(e) => {
            e.currentTarget.style.display = 'none';
            e.currentTarget.nextElementSibling?.classList.remove('hidden');
          }}
        />
        {/* Fallback Icon */}
        <TruckIcon className="hidden h-32 w-32 text-blue-600 dark:text-blue-500 relative z-10 drop-shadow-xl" />
      </div>
      <div className="text-center">
        <h1 className="text-4xl font-extrabold text-gray-900 dark:text-white tracking-tight mb-2">
          Путевые <span className="text-blue-600 dark:text-blue-500">Листы</span>
        </h1>
        <p className="text-gray-500 dark:text-gray-400 text-sm font-medium uppercase tracking-widest">
          Приложение для управления путевыми листами
        </p>
      </div>
      <div className="mt-12 flex space-x-2">
        <div className="w-3 h-3 bg-blue-600 rounded-full animate-bounce [animation-delay:-0.3s]"></div>
        <div className="w-3 h-3 bg-blue-600 rounded-full animate-bounce [animation-delay:-0.15s]"></div>
        <div className="w-3 h-3 bg-blue-600 rounded-full animate-bounce"></div>
      </div>
    </div>
  );
};
